// extracted by mini-css-extract-plugin
module.exports = {"containerNFP":"NotFound_styles_containerNFP__22S8D","gohome":"NotFound_styles_gohome__3_613"};